<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
          <h2>
        {{ isEditMode ? $t("navigations.manage lab test") : $t("navigations.create lab test") }}
      </h2>
        </div>
        <div class="col-lg-2">
            <span class="tooltip-wrapper pointer" style="float:right">
                <i class="fa fa-times close" @click="onclosed()"></i>
                <span class="custom-tooltip closetooltipposition">Close</span>
            </span>
        </div>
    </div>
    <div class="wrapper wrapper-content">
        <div class="ibox-content p-3">
            <div class="form-group row">
           
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.test code") }}  <sup><i class="fa fa-asterisk imp"></i></sup></label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.testCode"  :disabled="isEditMode" />
                    <span class="errormsg" v-if="errors[0] == false">{{ $t("navigations.please enter a test code") }}</span>
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.test name") }}<sup><i class="fa fa-asterisk imp"></i></sup></label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.testName"  :disabled="isEditMode" />
                    <span class="errormsg" v-if="errors[1] == false">{{ $t("navigations.please enter a test name") }}</span>
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.unit") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.unit" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.category") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.category" />
                </div>
               
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.method") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.method" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.cdisc variable") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.cdiscVariable" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.fhir resource") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.fhirResource" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">FHIR Code</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.fhirCode.code" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">FHIR Display</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.fhirCode.display" />
                </div>
                
                 <div class="col-lg-4 mb-1  d-flex align-items-center pt-4">
                    <label class="col-form-label  me-2 pt-0">{{ $t("navigations.allow unit conversion") }}</label>
                    <input type="checkbox" v-model="values.allowUnitConversion" />
                    
                </div>
                 <div class="col-lg-4 mb-1  d-flex align-items-center pt-4">
                    <label class="col-form-label me-2 pt-0">{{ $t("navigations.active") }}</label>
                    <input type="checkbox" v-model="values.active" />
                </div>

              
                <div class="col-lg-12 my-3 d-flex justify-content-lg-end">
                    <button class="cancel_btn py-1 px-4 mx-3" type="button" @click.prevent="clear">
                        {{ $t("navigations.clear") }}
                    </button>
                    <button class="save_btn py-1 px-4" type="submit" @click.prevent="addLab">
                        {{ $t("navigations.save") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script src="./editLabtest.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/savepages.css";
.wrapper-content {
    width: 100%;
}
textarea {
    width: 100%;
}
.imp {
    color: #ff0000;
    font-size: 7px;
}
.col-form-label {
    font-size: 12px;
}
.impcl {
    color: #ff4747;
    font-size: 25px;
    float: right;
}
.impcl:hover {
    color: #a30202;
    font-size: 25px;
    float: right;
}
.errormsg {
    color: red;
    font-size: 15px;
}
.form-select {
    border-radius: 0 !important;
}
.form-select:focus {
    border-color: #145faf !important;
    box-shadow: 0 0 0 !important;
}
</style>
